import SignInForm from "../organisms/forms/signIn/SignInForm";
import SignUpForm from "../organisms/forms/signUp/SignUpForm";
import { useTranslation } from "react-i18next";
import Content from "../templates/wrapper/Content";
import TabsRoot from "../molecules/tabs/TabsRoot";
import { useEffect,useContext } from "react";
import { useLocation, useNavigate,useSearchParams } from "react-router-dom";
import { useDialog } from "../../hooks/useDialog";
import { messageKeyMap } from "../../helpers/const";
import axios from "axios";
import { AuthContext } from "../../context/authContext";

export default function SignInPage() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const { showDialog } = useDialog();
  const [searchParams] = useSearchParams();
  const authContext = useContext(AuthContext);
    const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.type === "confirmUser" && location.state?.message) {
      showDialog(
        t("confirmUser.title"),
        t(location.state?.message),
        t("dialog.okey"),
        false,
        "",
        "success"
      );
      return;
    }

    const firstTrueKey = Object.keys(messageKeyMap).find(
      (key) => location.state?.[key]
    );

    if (firstTrueKey) {
      const message = t(messageKeyMap[firstTrueKey]);
      showDialog(
        "",
        message,
        t("dialog.okey"),
        true,
        "",
        "success",
        null,
        true
      );
    }
  }, [location.state, i18n.language, t]);

  useEffect(() => {
    const navigateMessage = localStorage.getItem("navigateMessage");
    
    if (!navigateMessage) return;
    const dialogMessage = Object.keys(messageKeyMap).find(
      (key) => navigateMessage === key
    );
    
    if (dialogMessage) {
      const message = t(messageKeyMap[dialogMessage]);
      localStorage.removeItem("navigateMessage");
      showDialog(
        "",
        message,
        t("dialog.okey"),
        true,
        "",
        "success",
        null,
        true
      );
    }
  }, [localStorage]);

   useEffect(() => {
    const code = searchParams.get("code");
    if (code !== null) {
      try {
        const data = {
          grant_type: "authorization_code",
          redirect_uri: process.env.REACT_APP_REDIRECT_URI,
          client_id: process.env.REACT_APP_CLIENT_ID,
          code: code,
        };
        axios
          .post(
            `${process.env.REACT_APP_COGNITO_SOCIAL_PROVIDER}/oauth2/token`,
            data,
            {
              headers: { "content-type": "application/x-www-form-urlencoded" },
            }
          )
          .then((response) => {
            authContext.authenticateUser(
              response.data.access_token,
              response.data.id_token,
              response.data.refresh_token
            );
            let attr = {
              Name: "custom:country",
              Value: "TR"
            };
            authContext.setAttribute(attr);
            navigate("/confirm-attribute");
          });
      } catch (error) {
        alert(error);
      }
    }
  }, []);

  const tabsData = [
    { value: "signIn", label: t("signUp.login"), content: <SignInForm /> },
    {
      value: "signUp",
      label: t("signUp.createAccount"),
      content: <SignUpForm />,
    },
  ];
  return (
    <>
      <Content>
        <TabsRoot tabs={tabsData} defaultValue="signIn" />
      </Content>
    </>
  );
}
